if (!customElements.get('wls-best-sellers')) {
  class WlsBestSellers extends HTMLElement {
    constructor() {
      super();
      this.swiper = null;
      this.resizeTimeout = null;
      this.onResize = this.onResize.bind(this);
    }

    connectedCallback() {
      this.slider = this.querySelector('.js-wls-best-sellers-swiper');
      this.slides = this.querySelectorAll('.js-wls-best-sellers-slide');
      this.prev = this.querySelector('.js-wls-best-sellers-prev');
      this.next = this.querySelector('.js-wls-best-sellers-next');
      this.pagination = this.querySelector('.js-wls-best-sellers-pagination');
      this.controls = this.querySelector('.js-wls-best-sellers-controls');
      this.count = this.slides.length;

      if (!this.slider || this.count === 0) {
        return;
      }

      requestAnimationFrame(() => this.updateLayout());
      window.addEventListener('resize', this.onResize);
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.onResize);
      this.destroySwiper();
      if (this.resizeTimeout) {
        clearTimeout(this.resizeTimeout);
      }
    }

    onResize() {
      if (this.resizeTimeout) {
        clearTimeout(this.resizeTimeout);
      }
      this.resizeTimeout = setTimeout(() => this.updateLayout(), 200);
    }

    destroySwiper() {
      if (this.swiper) {
        try {
          this.swiper.destroy(true, true);
        } catch (e) {
          /* ignore */
        }
        this.swiper = null;
      }
      if (this.slider) {
        this.slider.classList.add('wls-best-sellers__swiper--static');
      }
    }

    shouldUseSwiper() {
      const w = window.innerWidth;
      const mobile = w <= 1023;
      if (mobile) {
        return this.count > 1;
      }
      return this.count > 3;
    }

    updateLayout() {
      const mobile = window.innerWidth <= 1023;
      const useSwiper = this.shouldUseSwiper();

      this.classList.toggle('wls-best-sellers--desktop-grid', !mobile && this.count > 0 && this.count <= 3);
      this.classList.toggle('wls-best-sellers--nav-visible', useSwiper);

      this.destroySwiper();

      if (!useSwiper || typeof Swiper === 'undefined') {
        if (this.controls) {
          this.controls.hidden = true;
        }
        return;
      }

      if (this.controls) {
        this.controls.hidden = false;
      }

      const isMobile = mobile;
      /* Mobile: fixed slide width via CSS (slidesPerView 'auto'); desktop: 3 columns */
      const slidesPerView = isMobile ? 'auto' : 3;
      const spaceBetween = isMobile ? 16 : 24;
      const loop = isMobile ? this.count > 3 : this.count > 6;
      /* slidesOffsetBefore/After breaks centeredSlides (track is shifted; active slide is not viewport-centered). Use CSS padding on mobile instead. */
      const edgeInset = isMobile ? 0 : 16;

      try {
        /* Static layout uses grid on .swiper-wrapper; Swiper needs that class removed (same pattern as wls-testimonials). */
        this.slider.classList.remove('wls-best-sellers__swiper--static');
        this.swiper = new Swiper(this.slider, {
          slidesPerView,
          spaceBetween,
          loop,
          watchOverflow: true,
          observer: true,
          observeParents: true,
          slidesOffsetBefore: edgeInset,
          slidesOffsetAfter: edgeInset,
          centeredSlides: isMobile,
          centeredSlidesBounds: isMobile,
          navigation: {
            prevEl: this.prev,
            nextEl: this.next,
          },
          pagination: {
            el: this.pagination,
            clickable: true,
          },
        });
      } catch (e) {
        this.swiper = null;
        if (this.slider) {
          this.slider.classList.add('wls-best-sellers__swiper--static');
        }
        if (this.controls) {
          this.controls.hidden = true;
        }
      }
    }
  }

  customElements.define('wls-best-sellers', WlsBestSellers);
}
